import { t as uiText } from '../../i18n';
export const FLOATING_WIDGET_EMBED_SRC = 'https://notreu.com/widget/embed.js';

export function publishIdFromPublicUrl(publicUrl: string): string | null {
  const match = publicUrl.trim().match(/\/cg\/([^/?#]+)/i);
  return match?.[1] ?? null;
}

export function buildFloatingWidgetEmbedSnippet(params: {
  publishId: string;
  token?: string | null;
}): string {
  const tokenLine = params.token
    ? `\n  data-api-token="${params.token}"`
    : '';
  return uiText("<!-- notreu floating button -->\n<link rel=\"preconnect\" href=\"https://notreu.com\">\n<link rel=\"dns-prefetch\" href=\"https://notreu.com\">\n<script\n  src=\"{{FLOATING_WIDGET_EMBED_SRC}}\"\n  data-publish-id=\"{{publishId}}\"{{tokenLine}}\n  defer\n></script>", { FLOATING_WIDGET_EMBED_SRC: FLOATING_WIDGET_EMBED_SRC, publishId: params.publishId, tokenLine: tokenLine });
}

export function previewEmbedSnippet(full: string, max = 72): string {
  const oneLine = full.replace(/\s+/g, ' ').trim();
  if (oneLine.length <= max) return oneLine;
  return `${oneLine.slice(0, max)}…`;
}
